jQuery(document).ready(function (e) {  
$ = jQuery;

  $('.doctorssec_slider').slick();

  $(".whenyoutakecc_tablinks li").click(function(){
    var tabId = $(this).data("tab");
    $(".whenyoutakecc_tablinks li").removeClass("active");
    $(".tab").removeClass("active");
    $(this).addClass("active");
    $("#" + tabId).addClass("active");
  });

  $(".clinicallyvalidated_tablinks li").click(function(){
    var tabId = $(this).data("tab");
    $(".clinicallyvalidated_tablinks li").removeClass("active");
    $(".clinicalval_tab").removeClass("active");
    $(this).addClass("active");
    $("#" + tabId).addClass("active");
  });

  $(".startyourprotocol_btn").click(function(e){
    e.preventDefault(); // stop default anchor jump
    $('html, body').animate({
      scrollTop: $("#pricingtable_sec").offset().top
    }, 800); // speed = 800ms
  });

}); 